import React from 'react';
import ReminderMessageVariation from './ReminderMessageVariation'
import '../../App.css';
import '../../bootstrap.css';
import * as Database from '../../helpers/Database';
let _ = require('lodash');

const ACTIVITY_TYPE_DROPDOWN_MAP = {
  '': '',
  'food': 'food',
  'exercise': 'exercise',
  'body stats': 'weeklycheck'
};

export default class ReminderMessageBundle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newVariation: "",
      editingMessages: [], // Array of bool
      newMessages: [], // Array of string
      editingCondition: false,
      addingVariation: false,
      ifNotMessagedWithinHours: this.props.messageBundle.ifNotMessagedWithinHours != undefined ? this.props.messageBundle.ifNotMessagedWithinHours : 0,
      ifNotLoggedWithinHours: this.props.messageBundle.ifNotLoggedWithinHours != undefined ? this.props.messageBundle.ifNotLoggedWithinHours : 0,
      selectedActivityTypeText: this.props.messageBundle.type != undefined ? this.props.messageBundle.type : '',
      selectedActivityType: ACTIVITY_TYPE_DROPDOWN_MAP[this.props.messageBundle.type != undefined ? this.props.messageBundle.type : '']
    }

    this.enableReminder = this.enableReminder.bind(this);
    this.disableReminder = this.disableReminder.bind(this);

    this.conditionEdit = this.conditionEdit.bind(this);
    this.delete = this.delete.bind(this);

    this.variationAdd = this.variationAdd.bind(this);
    this.variationAddSave = this.variationAddSave.bind(this);
    this.variationAddCancel = this.variationAddCancel.bind(this);
    this.newVariationChange = this.newVariationChange.bind(this);
  }

  componentDidMount() {
    Database.doOnReadingFirebaseEntry(`${this.props.path}/image`, (snapshot) => {
      if (snapshot.exists()) {
        this.setState({
          includeWaistPic: snapshot.val()
        })
      }
    });
  }

  newVariationChange(e) {
    this.setState({newVariation: e.target.value})
  }

  variationAdd(e) {
    e.preventDefault();
    this.setState({addingVariation: true})
  }

  variationAddSave(e) {
    e.preventDefault();
    var pathRef = this.props.firebase.database().ref(this.props.path + '/messages');
    pathRef.once("value").then((snapshot) => {
      if (snapshot.exists()) {
        var nextIndex = snapshot.val().length;
        pathRef.child(nextIndex).set(this.state.newVariation)
      } else {
          pathRef.child("0").set(this.state.newVariation);
      }
      this.setState({addingVariation: false})
      this.props.refresh();
    }, function(error) {
        console.error(error);
    });
  }

  variationAddCancel(e) {
    e.preventDefault();
    this.setState({
      newVariation: "",
      addingVariation: false})
  }

  delete(e) {
    e.preventDefault();
    this.props.firebase.database().ref(e.target.name).set(null);
    if (this.props.hourPath) {
      this.props.firebase.database().ref(this.props.hourPath).once("value").then(function(snapshot) {
        if (snapshot.exists()) {
          var hourItems = snapshot.val();
          if (hourItems.intro && Object.keys(hourItems).length === 1) { // Only intro is left
            this.props.firebase.database().ref(this.props.hourPath).set(null);
          }
        } else {
          // TODO
        }
        this.props.refresh();
      }.bind(this), function(error) {
          console.error(error);
      });
    } else {
      this.props.refresh();
    }
  }

  enableReminder(e) {
    e.preventDefault();
    this.props.firebase.database().ref(e.target.name).set(false);
    this.props.refresh();
  }

  disableReminder(e) {
    e.preventDefault();
    this.props.firebase.database().ref(e.target.name).set(true);
    this.props.refresh();
  }

  conditionEdit(e) {
    e.preventDefault();
    this.setState({
      editingCondition: true,
      ifNotMessagedWithinHours: this.props.messageBundle.ifNotMessagedWithinHours != undefined ? this.props.messageBundle.ifNotMessagedWithinHours : 0,
      ifNotLoggedWithinHours: this.props.messageBundle.ifNotLoggedWithinHours != undefined ? this.props.messageBundle.ifNotLoggedWithinHours : 0
    });
  }

  ifNotMessagedWithinHoursChanged(e) {
    this.setState({ifNotMessagedWithinHours: e.target.value});
  }

  ifNotLoggedWithinHoursChanged(e) {
    this.setState({ifNotLoggedWithinHours: e.target.value});
  }

  selectedActivityTypeChange(e) {
    this.setState({
      selectedActivityTypeText: e.target.value,
      selectedActivityType: ACTIVITY_TYPE_DROPDOWN_MAP[e.target.value]
    });
  }

  saveEditConditions(e) {
    this.props.firebase.database().ref(`${e.target.name}/ifNotMessagedWithinHours`).set(_.toNumber(this.state.ifNotMessagedWithinHours));
    this.props.firebase.database().ref(`${e.target.name}/ifNotLoggedWithinHours`).set(_.toNumber(this.state.ifNotLoggedWithinHours));
    this.props.firebase.database().ref(`${e.target.name}/type`).set(this.state.selectedActivityType ? this.state.selectedActivityType : null);
    this.setState({editingCondition: false});
    this.props.refresh();
  }

  cancelEditConditions(e) {
    this.setState({editingCondition: false});
  }

  checkboxChanged(event) {
    let target = event.target;
    let value = target.checked;
    let name = target.name;
    this.setState({
      [name]: value
    });

    if (name === 'includeWaistPic') {
      Database.setFirebaseEntry(`${this.props.path}/image`, 'waist');
    }
  }

  render() {
    let disabled;
    if (this.props.messageBundle.disabled) {
      disabled = (<li><span style={{color:"red"}}>Disabled</span> <input type="submit" name={this.props.path + '/disabled'} onClick={this.enableReminder} value="Enable"/> <input style={{marginLeft:"20px", color:"red"}} type="submit" name={this.props.path} onClick={this.delete} value="DELETE"/></li>);
    }
    else {
      disabled = (<li><span style={{color:"green"}}>Enabled</span>  <input type="submit" name={this.props.path + '/disabled'} onClick={this.disableReminder} value="Disable"/> <input style={{marginLeft:"20px", color:"red"}} type="submit" name={this.props.path} onClick={this.delete} value="DELETE"/></li>);
    }

    let messageButtons = <span/>;
    let messages = (<span/>)

    if (this.props.messageBundle.messages) {
      messages = this.props.messageBundle.messages.map((messageText, index) =>
        <ReminderMessageVariation firebase={this.props.firebase} refresh={this.props.refresh} path={this.props.path + '/messages/' + index} message={messageText}/>
      );
    }

    let loggedCondition;
    let messagedCondition;
    let conditionsBlock;


    if (this.props.ignoreCondition) {
      conditionsBlock = (<span />);
    } else {
      let conditionButtons;
      // NOTE: Not including daily & weekly habits in the dropdown below because need to figure out how to handle food quality habit add/deletes complicating things (see onFoodAddOrDelete in UserPanel.js)
      let activityTypeDropdown = (
        <select value={this.state.selectedActivityTypeText} onChange={this.selectedActivityTypeChange.bind(this)}>
        {
          Object.keys(ACTIVITY_TYPE_DROPDOWN_MAP).map(key => {
            return (<option>{key}</option>);
          })
        }
        </select>);

      if (this.state.editingCondition) {
        loggedCondition = (
          <li>
            Only sent if no {activityTypeDropdown} logged in the last <input type="number" style={{width:"50px"}} value={this.state.ifNotLoggedWithinHours} onChange={this.ifNotLoggedWithinHoursChanged.bind(this)}/> HOUR(S).
          </li>);

        messagedCondition = (
          <li>
            Only sent if nobody said anything in last <input type="number" style={{width:"50px"}} value={this.state.ifNotMessagedWithinHours} onChange={this.ifNotMessagedWithinHoursChanged.bind(this)}/> HOUR(S).
          </li>);

        conditionButtons = (
          <span>
            <input type="submit" name={this.props.path} onClick={this.saveEditConditions.bind(this)} value="Save"/>
            <input type="submit" onClick={this.cancelEditConditions.bind(this)} value="Cancel"/>
          </span>);
      } else {
        conditionButtons = (<input type="submit" onClick={this.conditionEdit} value="Edit condition"/>);
        loggedCondition = (<div>Sent regardless of what last got logged.</div>);
        messagedCondition = (<div>Sent regardless of who last sent a message.</div>);
        
        let messageBundle = this.props.messageBundle;

        let ifNotLoggedWithinHours = messageBundle.ifNotLoggedWithinHours != undefined ?
          messageBundle.ifNotLoggedWithinHours : 0;

        if (_.toNumber(ifNotLoggedWithinHours)) {
          if (messageBundle.type) {
            if (messageBundle.subtype) {
              if (messageBundle.subtypeId) {
                let subtype = messageBundle.subtype;
                let subtypeId = messageBundle.subtypeId;
                let subtypeName;
                if (this.props.workoutsMap && subtype === "workouts") {
                  subtypeName = this.props.workoutsMap[subtypeId];
                } else if (this.props.dailyHabitsMap && messageBundle.type === "habit" && subtype === "daily") {
                  subtypeName = this.props.dailyHabitsMap[subtypeId];
                } else if (this.props.weeklyHabitsMap && messageBundle.type === "habit" && subtype === "weekly") {
                  subtypeName = this.props.weeklyHabitsMap[subtypeId];
                } else {
                  subtypeName = subtypeId;
                }

                loggedCondition = (<div>
                  Only sent if no <i style={{color:"blue"}}>'{messageBundle.type}-{messageBundle.subtype}-{subtypeName}'</i> logged in the last <i style={{color:"blue"}}>{ifNotLoggedWithinHours} HOUR(S)</i>
                </div>);
              } else {
                loggedCondition = (<div>
                  Only sent if no <i style={{color:"blue"}}>'{messageBundle.type}-{messageBundle.subtype}'</i> logged in the last <i style={{color:"blue"}}>{ifNotLoggedWithinHours} HOUR(S)</i>
                </div>);
              }
            } else {
              loggedCondition = (<div>
                Only sent if no <i style={{color:"blue"}}>'{messageBundle.type}'</i> logged in the last <i style={{color:"blue"}}>{ifNotLoggedWithinHours} HOUR(S)</i>
              </div>);
            }
          } else {
            // ifNotLoggedWithinHours only take efect if we have a "type" of logged to watch out for.
          }
        }

        let ifNotMessagedWithinHours = messageBundle.ifNotMessagedWithinHours != undefined ?
          messageBundle.ifNotMessagedWithinHours : 0;

        if (_.toNumber(ifNotMessagedWithinHours)) {
            messagedCondition = (<div>
              Only sent if nobody said anything in the last <i style={{color:"blue"}}>{ifNotMessagedWithinHours} HOUR(S)</i>
            </div>);
        }
      }

      conditionsBlock = (<li>
        <b>Conditions</b>
        <ol>
          <li>{loggedCondition}</li>
          <li>{messagedCondition}</li>
        </ol>
        {conditionButtons}
      </li>);
    }

    var addNewVariation = this.state.addingVariation ?
    (<div>
      New variation: <input type="text" value={this.state.newVariation} onChange={this.newVariationChange}/>
      <input type="submit" onClick={this.variationAddSave} value="Save"/>
      <input type="submit" onClick={this.variationAddCancel} value="Cancel"/>
    </div>) :
    (<input type="submit" onClick={this.variationAdd} value="Add new message variation"/>);

    let messageContent = this.props.messageBundle.type === 'crewreport' ?
      (<span>[CREW REPORT]</span>) : (
        <div>
        <li><b>Message variations (1 picked at random to send)</b> 
            <ul>
              {messages}
            </ul>
            {addNewVariation}
          </li>
          { this.props.messageBundle.type === 'weeklycheck' ?
            (<div>
              <input type='checkbox' name='includeWaistPic' checked={this.state.includeWaistPic} onChange={this.checkboxChanged.bind(this)}></input> Include WAIST MEASUREMENT picture
              </div>) : (<span/>)
          }
          {conditionsBlock}
        </div>
      );

    return (
      <span>
        <ul>
          <b>{disabled}</b>
          {messageContent}
        </ul>
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/main/reminders/ReminderMessageBundle.js